export default "__VITE_ASSET__zsHimTi0__"